import {
    deleteCookie,
    getCookie,
    setCookie,
} from '@vfde-sails/utils';
import { Cookies } from '../enum';

/**
 * Checks if cookie is present by name
 */
export const isCookiePresent = (name: Cookies): boolean => !!getCookie(name);

/**
 * Sets 3P Cookie with an expiration of 1 day
 */
export const set3PCookie = () => setCookie(Cookies.THREE_P, { value: 'true', expires: 86400 });

/**
 * Remove gigakombi cookie
 */
export const removeGigakombiCookie = () => deleteCookie(Cookies.GIGAKOMBI);
